import {
  Modal,
  ModalBody,
  ModalFooter,
  Button,
  Row,
  Col
} from 'reactstrap';
import { faDownload, faTimes } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const InvoiceModal = ({ isOpen, toggle, transaction }) => {
  const currentDate = new Date().toLocaleDateString('en-IN', {
    year: 'numeric',
    month: 'long',
    day: 'numeric'
  });

  const receiptDate = transaction?.createdat
  ? new Date(transaction.createdat).toLocaleDateString('en-IN', {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
    })
  : '';

  const getPlanName = (planId) => {
    const planMap = {
      'plan_inr_monthly': 'Tribune India Monthly Premium Membership',
      'plan_usd_monthly': 'Tribune India Monthly Premium Membership',
      'plan_inr_yearly': 'Tribune India Yearly Premium Membership',
      'plan_usd_yearly': 'Tribune India Yearly Premium Membership',
      'plan_usd_epaper_combo_yearly': 'Tribune India Yearly Combo (Digital + Epaper) Membership',
      'plan_inr_epaper_combo_yearly': 'Tribune India Yearly Combo (Digital + Epaper) Membership',
      'plan_usd_epaper_combo_30_months': 'Tribune India 2 year+6 months Baisakhi Sale (Digital + Epaper) Membership',
      'plan_inr_epaper_combo_30_months': 'Tribune India 2 year+6 months Baisakhi Sale (Digital + Epaper) Membership'
    };
    return planMap[planId] || planId || '';
  };

  const getStatusText = (status) => {
    const statusMap = {
      0: 'Initiated',
      1: 'Order Created',
      '-1': 'Order Could Not Create',
      2: 'Completed',
      '-2': 'Failed',
      '-3': 'Cancelled'
    };
    return statusMap[status] || status || '';
  };

  // Financial calculations
  const currency = transaction?.currency || 'INR';
  const grossTotal = (transaction?.amount || 0) / 100;
  const igstRate = 0.18;
  const baseAmount = grossTotal / (1 + igstRate);
  const igstAmount = grossTotal - baseAmount;
  const grossRate = grossTotal - igstAmount;
  const conversionRate = 85;

  const formatAmount = (amount, curr) => {
    if (curr === 'USD') {
      return `${amount.toFixed(2)}`;
    }
    return `${amount.toFixed(2)}`;
  };

  const formatCurrencySymbol = (curr) => {
    const symbol = curr === 'USD' ? '$' : '₹';
    return symbol;
  };

  const generatePDF = () => {
      const iframe = document.createElement('iframe');
      iframe.style.position = 'absolute';
      iframe.style.top = '-10000px';
      iframe.style.left = '-10000px';
      iframe.style.width = '0px';
      iframe.style.height = '0px';
      iframe.style.border = 'none';

      document.body.appendChild(iframe);

    const invoiceHTML = `<!DOCTYPE html>
<html lang="en">
<head>
    <meta charset="UTF-8">
    <meta name="viewport" content="width=device-width, initial-scale=1.0">
    <title>Receipt - Tribune India Membership</title>
    <style>
        @media print {
            @page {
                size: A4;
                margin: 0.5in;
            }
            body {
                -webkit-print-color-adjust: exact;
                print-color-adjust: exact;
            }
        }
        
        body {
            margin: 0;
            background-color: #fff;
            color: #000;
        }
        
        .receipt-container {
            width: 650px;
            height: 899px;
            margin: 0 auto;
            background: white;
            font-family: Times New Roman, sans-serif;
            font-size: 17px;
            line-height: 1.2;
        }
        
        .receipt-title {
            text-align: center;
            font-size: 30px;
            font-weight: bold;
            margin-bottom: 20px;
        }
        
        .header-section {
            display: flex;
            justify-content: space-between;
            margin-bottom: 40px;
        }
        
        .company-info {
            flex: 1;
        }
        
        .company-name {
            margin-bottom: 3px;
        }
        
        .company-details {
            margin: 2px 0;
        }
        
        .receipt-details {
            text-align: left;
            flex: 0 0 290px;
        }
        
        .receipt-details div {
            margin: 3px 0;
        }
        
        .client-section {
            margin: 20px 0;
        }
        
        .client-header {
            font-weight: bold;
            margin-bottom: 5px;
        }
        
        .client-info {
        }
        
        .client-info div {
            margin: 2px 0;
        }
        
        .earnings-banner {
            background: #d3d3d3;
            text-align: center;
            padding: 8px;
            font-weight: bold;
            border: 1px solid #e5e5e5;
            border-bottom: none;
        }
        
        .earnings-subtitle {
            font-size: 10px;
            font-weight: normal;
            margin-top: 3px;
        }
        
        .receipt-table {
            width: 100%;
            border-collapse: collapse;
            border-color: #000;
        }
        
        .receipt-table td {
            border: 1px solid #000;
            padding: 20px 8px;
            vertical-align: middle;
        }
        
        .table-header {
            font-weight: bold;
            text-align: center;
        }
        
        .table-header-row td {
            padding-top: 6px;
            padding-bottom: 6px;
        }
        
        .description-col { 
            width: 75%; 
        }
        
        .amount-col { 
            width: 25%; 
            text-align: right; 
        }
        
        .total-row { 
            font-weight: bold; 
        }

        .total-row td { 
            padding-top: 15px;
            padding-bottom: 15px;
        }
        
        .final-total-row { 
            font-weight: bold; 
        }

        .final-total-row td {
            padding-top: 15px;
            padding-bottom: 15px;
        }

        .igst-row td {
          padding-top: 6px;
          padding-bottom: 6px;
        }
        
        .footer-info { 
            margin-top: 20px; 
            font-size: 15px; 
        }
        
        .footer-info div { 
            margin: 10px 0; 
        }
        
        .note-cell {
            font-size: 16px;
            margin-top: 10px;
        }

        .currency-symbol {
            font-size: 15.5px;
        }
        
        .customer-contact a {
            color: blue;
            text-decoration: underline;
        }
    </style>
</head>
<body>
    <div class="receipt-container">
        <div class="receipt-title">Receipt</div>
        
        <div class="header-section">
            <div class="company-info">
                <div class="company-name">Tribune India</div>
                <div class="company-details">subsmail@tribunemail.com</div>
                <div class="company-details">SECTOR 29-C, CHANDIGARH</div>
                <div class="company-details">160030</div>
            </div>
            <div class="receipt-details">
                <div>Transaction reference:</div>
                <div>${transaction?.pg_txn_id || ''}</div>
                <div>Date: ${receiptDate}</div>
            </div>
        </div>

        <div class="client-section">
            <div class="client-header">Bill To:</div>
            <div class="client-info">
                <div><strong>${transaction?.user_id?.name || ''}</strong></div>
                <div class="customer-contact">
                    <a href="mailto:${transaction?.user_id?.email || ''}">${transaction?.user_id?.email || ''}</a>${transaction?.user_id?.phone_number && transaction?.user_id?.email ? ' / ' : ''} ${transaction?.user_id?.phone_number ? transaction.user_id.phone_number : ''}
                </div>
            </div>
        </div>

        <table class="receipt-table">
            <tr class="table-header-row">
                <td class="table-header description-col">Item Description</td>
                <td class="table-header amount-col">Amount</td>
            </tr>
            
            <tr>
                <td>
                    ${getPlanName(transaction?.subscription_id?.plan_id)}
                    <div class="note-cell">Please note the subscription will be active from the date of purchase.</div>
                </td>
                <td class="amount-col"><span class="currency-symbol">${formatCurrencySymbol(currency)}</span>${formatAmount(grossRate, currency)}</td>
            </tr>
            
            <tr class="igst-row">
                <td>IGST @ 18%</td>
                <td class="amount-col"><span class="currency-symbol">${formatCurrencySymbol(currency)}</span>${formatAmount(igstAmount, currency)}</td>
            </tr>
            
            <tr class="total-row">
                <td>Gross Total:</td>
                <td class="amount-col"><span class="currency-symbol">${formatCurrencySymbol(currency)}</span>${formatAmount(grossTotal, currency)}</td>
            </tr>
            
            <tr class="final-total-row">
                <td></td>
                <td class="amount-col">Paid : <span class="currency-symbol">${formatCurrencySymbol(currency)}</span>${formatAmount(grossTotal, currency)}</td>
            </tr>
        </table>

        <div class="footer-info">
            <div><strong>Billed by Sortd on behalf of Tribune India</strong></div>
        </div>
    </div>
</body>
</html>`
    iframe.contentDocument.open();
    iframe.contentDocument.write(invoiceHTML);
    iframe.contentDocument.close();

    // Wait for content to load, then print
    iframe.onload = function () {
      setTimeout(() => {
        // Set the document title for the iframe content
        iframe.contentDocument.title = 'Receipt - Tribune India Membership';

        // Store original title and temporarily change main window title
        const originalTitle = document.title;
        document.title = `Receipt-TribuneIndiaMembership-${transaction?.user_id?.name ? transaction.user_id.name : transaction?.user_id?.email ? transaction.user_id.email : transaction?.user_id?.phone_number || transaction?.pg_txn_id || ''}`;

        iframe.contentWindow.print();

        // Restore original title after printing
        setTimeout(() => {
          document.title = originalTitle;
        }, 1000);

        // Clean up: remove iframe after a short delay
        setTimeout(() => {
          document.body.removeChild(iframe);
        }, 1000);
      }, 100);
    };
  };

  const handleDownloadPDF = () => {
    generatePDF();
  };

  return (
    <Modal isOpen={isOpen} toggle={toggle} size="lg">
      <div style={{ fontFamily: "'Times New Roman', Times, serif" }}>
        <ModalBody>
          <div id="invoice-content">
            <div className="mb-4">
              <h2 className="text-center mb-4" style={{ color: '#2c3e50' }}>Receipt</h2>
              <Row>
                <Col md={8}>
                  <h5 className="mb-0" style={{ color: '#2c3e50', fontWeight: 'bold' }}>Mediology Software</h5>
                  <p>
                    Tribune India <br />
                    subsmail@tribunemail.com <br />
                    SECTOR 29-C, CHANDIGARH - <br />
                    160030 
                  </p>
                </Col>
                <Col md={4}>
                  <p><strong>Transaction reference:</strong><br />
                    <span style={{ wordBreak: 'break-word' }}>{transaction?.pg_txn_id || ''}</span>
                  </p>
                  <p><strong>Date:</strong> {receiptDate}</p>
                </Col>
              </Row>
            </div>

            <div className="mb-4">
              <h5 style={{ color: '#2c3e50' }}>Bill To:</h5>
              <p className="mb-1">{transaction?.user_id?.name || ""}</p>
              <p>{transaction?.user_id?.email || ''} {transaction?.user_id?.phone_number && transaction?.user_id?.email ? ' / ' : ''} {transaction?.user_id?.phone_number ? `${transaction?.user_id?.phone_number}` : ''}</p>
            </div>

            <div className="table-responsive">
              <table className="table table-bordered">
                <thead className="table-light">
                  <tr>
                    <th style={{ width: '70%' }}>Item Description</th>
                    <th style={{ width: '30%' }} className="text-end">Amount</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>
                      {getPlanName(transaction?.subscription_id?.plan_id)}
                      <br /><br />
                      <p>Please note the subscription will be active from the date of purchase.</p>
                    </td>
                    <td className="text-end"><strong><span class="currency-symbol">{formatCurrencySymbol(currency)}</span>{formatAmount(grossRate, currency)}</strong></td>
                  </tr>
                  <tr>
                    <td>IGST @ 18%</td>
                    <td className="text-end"><strong><span class="currency-symbol">{formatCurrencySymbol(currency)}</span>{formatAmount(igstAmount, currency)}</strong></td>
                  </tr>
                  <tr className="table-secondary">
                    <td><strong>Gross Total :</strong></td>
                    <td className="text-end"><strong><span class="currency-symbol">{formatCurrencySymbol(currency)}</span>{formatAmount(grossTotal, currency)}</strong></td>
                  </tr>
                  <tr className="table-secondary">
                    <td><strong>Paid :</strong></td>
                    <td className="text-end"><strong><span class="currency-symbol">{formatCurrencySymbol(currency)}</span>{formatAmount(grossTotal, currency)}</strong></td>
                  </tr>
                </tbody>
              </table>
            </div>

            <div><small>Billed by SORTD on behalf of Tribune India</small></div>
          </div>
        </ModalBody>
        <ModalFooter>
          <Button color="primary" onClick={handleDownloadPDF}>
            <FontAwesomeIcon icon={faDownload} className="me-2" />
            Download Invoice
          </Button>
          <Button color="secondary" onClick={toggle} className="mx-3">
            <FontAwesomeIcon icon={faTimes} className="me-2" />
            Close
          </Button>
        </ModalFooter>
      </div>
    </Modal>
  );
};

export default InvoiceModal;